const typeConversionToStringArray = (value?: string | string[]) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value;
  } else {
    return [value];
  }
};

const typeConversionToNumberArray = (value?: string | string[]) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.map((el) => Number(el));
  } else {
    return [Number(value)];
  }
};

export { typeConversionToStringArray, typeConversionToNumberArray };
